var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenshotSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16327 16.5H17.8367C19.6179 16.5 20.5 15.5961 20.5 13.8058V3.19419C20.5 1.40386 19.6179 0.5 17.8367 0.5H3.16327C1.39059 0.5 0.5 1.39517 0.5 3.19419V13.8058C0.5 15.6048 1.39059 16.5 3.16327 16.5ZM14.5882 8.47827C14.2065 8.13064 13.7655 7.94813 13.3075 7.94813C12.841 7.94813 12.4254 8.11325 12.0352 8.46958L8.20144 11.9807L6.63232 10.5206C6.27608 10.1991 5.88592 10.0253 5.48728 10.0253C5.1056 10.0253 4.74936 10.1904 4.39313 10.5119L1.86556 12.8498V3.26372C1.86556 2.35986 2.33206 1.89924 3.18024 1.89924H17.8198C18.6595 1.89924 19.1344 2.35986 19.1344 3.26372V12.8585L14.5882 8.47827ZM6.81891 8.57387C7.91306 8.57387 8.81213 7.65263 8.81213 6.52281C8.81213 5.40168 7.91306 4.47175 6.81891 4.47175C5.71628 4.47175 4.81722 5.40168 4.81722 6.52281C4.81722 7.65263 5.71628 8.57387 6.81891 8.57387Z",
    fill: "#A41A45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshotSelected);
export default __webpack_public_path__ + "static/media/screenshot_selected.3756a2fa2910935cc1165fba9508e4ce.svg";
export { ForwardRef as ReactComponent };